import { FinanceType, Locales, MerchantType, TransactionType, TypeOfPerson, WhtAmountType } from "@/enums/enums";
import { i18n } from "@/i18n";

export function NewObject(obj: any) {
  if (obj == "") {
    return "";
  } else {
    return JSON.parse(JSON.stringify(obj));
  }
}

export function GetTypeOfPersonBySearchedAddress(merchantType: MerchantType) {
  switch (merchantType) {
    case MerchantType.OrdinaryPerson:
    case MerchantType.OrdinaryPartnership:
    case MerchantType.Shop:
    case MerchantType.BodyOfPersons:
      return { name: "บุคคลธรรมดา", value: TypeOfPerson.OrdinaryPerson };
      break;
    case MerchantType.JointVenture:
    case MerchantType.Association:
    case MerchantType.Foundation:
    case MerchantType.LimitedLiabilityPartnership:
    case MerchantType.PublicCompanyLimited:
    case MerchantType.CompanyLimited:
    case MerchantType.Others:
      return { name: "นิติบุคคล", value: TypeOfPerson.JuristicPerson };
      break;
  }
}

export function GetWhtAmountValue(whtAmountType: WhtAmountType) {
  let whtAmountValue: any = "";
  switch (whtAmountType) {
    case WhtAmountType.Auto:
      whtAmountValue = null;
      break;
    case WhtAmountType.NotSpecify:
      whtAmountValue = null;
      break;
    case WhtAmountType.None:
      whtAmountValue = 0;
      break;
    case WhtAmountType.Custom:
      whtAmountValue = 0;
      break;
    case WhtAmountType.ZeroPointSevenFive:
      whtAmountValue = 0.75;
      break;
    case WhtAmountType.OnePercent:
      whtAmountValue = 1;
      break;
    case WhtAmountType.TwoPercent:
      whtAmountValue = 2;
      break;
    case WhtAmountType.ThreePercent:
      whtAmountValue = 3;
      break;
    case WhtAmountType.FivePercent:
      whtAmountValue = 5;
      break;
    case WhtAmountType.TenPercent:
      whtAmountValue = 10;
      break;
    case WhtAmountType.FifteenPercent:
      whtAmountValue = 15;
      break;
    case WhtAmountType.OnePointFivePercent:
      whtAmountValue = 1.5;
      break;
  }

  return whtAmountValue;
}

export function ChangeNameByLanguageType(name: any) {
  if (i18n.locale === Locales.EN) {
    return name.english;
  } else {
    return name.thai;
  }
}

export function GetDocumentName(transactionType: TransactionType, financeType: FinanceType) {
  let documentName: any = "";
  switch (transactionType) {
    case TransactionType.Quotation:
      documentName = i18n.t("Quotation");
      break;
    case TransactionType.Invoice:
      {
        if (financeType === FinanceType.InFlow) {
          documentName = i18n.t("Invoice");
        } else {
          documentName = i18n.t("Expense");
        }
      }
      break;
    case TransactionType.Receipt:
      documentName = i18n.t("Receipt");
      break;
  }
  return documentName;
}

const setCookie = (name: string, value: string, days: number): void => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
};

const getCookie = (name: string): string | null => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
};

const deleteCookie = (name: string): void => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Strict`;
};

export function GetCookie(cookieName: string) {
  return getCookie(cookieName);
}

export function SetCookie(cookieName: string, value: any, expireDays: number) {
  setCookie(cookieName, value, expireDays);
}

export function DeleteCookie(cookieName: string) {
  deleteCookie(cookieName);
}
